define((require) => {
    "use strict";

    const CONSTANTS                           = require("ui/editor/email/Constants");
    const EventDispatcher                     = require("shared/util/EventDispatcher");
    const IncompatibleWidgetsPopupModel       = require("ui/editor/email/IncompatibleWidgetsPopupModel");
    const NotificationBar                     = require("editor/ui/notificationbar/NotificationBar");

    const ALLOWED_WIDGETS_FOR_EMAIL = [
        "text",
        "text-enhanced",
        "image",
        "link",
        "button",
        "line",
        "shape"
    ];

    const widgetTypes = {
        "text": "Text",
        "text-enhanced": "Enhanced text",
        "image": "Image",
        "link": "Link",
        "embed": "Embeded URL",
        "html": "HTML",
        "youtube": "Youtube",
        "social-sharing": "Social sharing links",
        "button": "Button",
        "scene-navigator": "Scene navigator",
        "shape": "Shape",
        "line": "Line",
        "demandware": "Cloud product",
        "dynamic-product": "Enhanced product",
        "composite": "Group"
    };

    const widgetImagesURL = {
        "images/image_default_previous_scene.svg": "Previous scene",
        "images/image_default_next_scene.svg": "Next scene"
    };

    /**
     * Widget validation class.
     *
     * <p>Allows to validate widgets for compatibility to "EmailMode",
     *  and returns an array of widgets incompatible with the mode</p>
     *
     * @class WidgetValidator
     * @constructor
     */
    const WidgetValidator = EventDispatcher.extend({

        getIncompatibleWidgetsNames(incompatibleWidgets) {
            return incompatibleWidgets.map(({widgetName}) => widgetName)
                .filter((widgetName, i, widgetsNameArray) => widgetsNameArray.indexOf(widgetName) === i)
                .join(", ");
        },

        getActiveIncompatibleEmailWidgets({
            widgetModelsToCheck, systemMessage, isEmailMode = true, viewModel
        }) {
            const allIncompatibleWidgets = [];

            const checkIncompatibleWidgets = (widgetModels) => {
                widgetModels.forEach((widgetModel) => {
                    const group = widgetModel.get("group");
                    const type = widgetModel.get("type");
                    if (group) {
                        checkIncompatibleWidgets(group.models);
                    }
                    if (!ALLOWED_WIDGETS_FOR_EMAIL.includes(type)) {
                        if (type === "image") {
                            widgetModel.widgetName = widgetImagesURL[widgetModel.attributes.imageUrl];
                        } else {
                            widgetModel.widgetName = widgetTypes[widgetModel.attributes.type];
                        }
                        allIncompatibleWidgets.push(widgetModel);
                    }
                });
            };
            checkIncompatibleWidgets(widgetModelsToCheck);
            const isRemoveIncompatibleWidgetNotificationOpen = () => {
                const notification = NotificationBar.list().find((notification) => notification.message.includes("This experience contains widgets which cannot be used in emails"));
                if (notification && viewModel) {
                    NotificationBar.close({id: notification.id});
                }
            };
            /**
             * Display list of incompatible widgets to user
             */

            isRemoveIncompatibleWidgetNotificationOpen();
            const widgetsName = this.getIncompatibleWidgetsNames(allIncompatibleWidgets);
            if (!viewModel && widgetsName.length) {
                systemMessage = systemMessage.replace(": ", `: ${widgetsName}`);
                NotificationBar.open(systemMessage, {closeDelay: 5000});
            } else if (isEmailMode && allIncompatibleWidgets.length) {
                const popupModel = new IncompatibleWidgetsPopupModel({
                    allIncompatibleWidgets: allIncompatibleWidgets,
                    viewModel: viewModel,
                    widgetsName: widgetsName,
                    systemMessage: systemMessage
                });
                popupModel.set({state: CONSTANTS.OPEN_NOTIFICATION});
            }

            return allIncompatibleWidgets;
        }
    });

    return new WidgetValidator();
});



// WEBPACK FOOTER //
// ./src/editor/services/WidgetValidator.js